/* Fransk katalog for locale-completion-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  "common.rowUnavailable": "Les donn?es n?ont pas pu ?tre charg?es. R?essayez.",
  "common.rowContextChanged": "L?entreprise ou le document s?lectionn? a chang?. Ouvrez-le ? nouveau.",
  "common.bankStatementIncomplete": "Le relev? bancaire n?est pas enti?rement charg?. R?essayez.",
  "common.journalProofUnavailable": "Les donn?es comptables n?ont pas pu ?tre v?rifi?es.",

  'pay.employeesAwaitingPayment': '{{count}} salariés en attente de paiement',
  'pay.readyForPayment': 'Prêt pour le paiement',
  'pay.readyForPaymentHelp': 'Traitements de paie approuvés et comptabilisés dont le salaire n\'est pas encore enregistré comme versé.',
  'pay.noRunsAwaitingPayment': 'Aucun traitement de paie en attente de paiement',
  'pay.noRunsAwaitingPaymentHint': 'Les traitements de paie approuvés apparaissent ici jusqu\'à l\'enregistrement du paiement.',
  'pay.draftPayrollRuns': 'Brouillons',
  'pay.noDraftPayrollRuns': 'Aucun brouillon de paie.',
  'buy.ownerOutlay': 'Débours du propriétaire',
  'home.followup.assetPostingTitle': 'Amortissements',
  'home.followup.assetPostingAction': 'Voir l\'écart',
  'home.followup.assetPostingIssue': 'L\'amortissement automatique nécessite un suivi. Vérifiez le plan de l\'actif ou contactez le support. Plumme réessaie une fois l\'écart corrigé.',
  'ui.cancel': 'Annuler',
  'ui.close': 'Fermer',
  'ui.back': 'Retour',
  'ui.continue': 'Continuer',
  'ui.open': 'Ouvrir',
  'app.close': 'Fermer',
  'common.loadMore': 'Charger plus', 'common.loading': 'Chargement...',
  'shell.collapse': 'Réduire le menu',
  'chat.cardFromFirm': 'Votre comptable a écrit',
  'chat.cardFromYou': 'Vous avez écrit',
  'chat.cardNone': 'Aucun message pour l\'instant',
  'chat.firm': 'Votre comptable',
  'chat.helpTitle': 'Votre comptable',
  'chat.help': 'Écrivez directement à votre comptable. Seuls vous, en tant que propriétaire ou administrateur, voyez cette conversation.',
  'chat.cardOpenUnread': 'Lire le message',
  'chat.cardOpen': 'Envoyer un message',
  'chat.modalTitle': 'Vous avez un message non lu',
  'chat.modalOpen': 'Ouvrir le chat',
  'chat.modalBody': 'vous a envoyé un message que vous n\'avez pas lu.',
  'chat.client': 'Le client',
  'chat.subFirm': 'Échange avec le client',
  'chat.subClient': 'Échange avec votre comptable',
  'chat.emptyFirm': 'Aucun message pour l\'instant. Écrivez au client ici — il le verra dans Plumme.',
  'chat.emptyClient': 'Aucun message pour l\'instant. Posez vos questions à votre comptable.',
  'chat.placeholder': 'Écrire un message …',
  'chat.send': 'Envoyer',
  'rf.client.takeoverSaved': 'La date de reprise a été enregistrée',
  'rf.client.takeover': 'Date de reprise',
  'rf.client.takeoverHelp': 'Les périodes et échéances antérieures à cette date ne sont pas considérées comme le travail du cabinet. Les obligations propres du client ne changent pas.',
  'rf.client.takeoverSave': 'Enregistrer la date',
  'clo.cash.invalidAmount': 'Saisissez le montant de caisse compté.',
  'clo.cash.documentationRequired': 'Décrivez la justification du comptage avant de valider.',
  'clo.cash.saved': 'Le comptage de caisse a été enregistré.',
  'clo.cash.saveError': 'Impossible d\'enregistrer le comptage de caisse.',
  'clo.cash.title': 'Pièces et billets',
  'clo.cash.readySubtitle': 'La caisse a été comptée et concorde avec le compte 1900.',
  'clo.cash.naSubtitle': 'Aucun solde de caisse n\'est enregistré sur le compte 1900.',
  'clo.cash.todoSubtitle': 'Comptez la caisse au 31.12 et comparez avec le compte 1900.',
  'clo.cash.noStatus': 'Le statut de la caisse n\'est pas encore calculé.',
  'clo.cash.booked': 'Comptabilisé sur 1900',
  'clo.cash.counted': 'Compté au 31.12',
  'clo.cash.difference': 'Écart',
  'clo.cash.countedField': 'Montant de caisse compté',
  'clo.cash.account': 'Compte de caisse',
  'clo.cash.documentation': 'Justification du comptage',
  'clo.cash.documentationPlaceholder': 'Par exemple : caisse comptée le 31.12 par le directeur général. La fiche de comptage est classée avec les justificatifs.',
  'clo.cash.noDifferenceHelp': 'Lorsque le montant compté concorde avec le compte 1900, le comptage est enregistré comme justificatif sans écriture supplémentaire.',
  'clo.cash.surplusHelp': 'L\'écart augmente le compte 1900 et est comptabilisé en autres produits.',
  'clo.cash.shortageHelp': 'L\'écart diminue le compte 1900 et est comptabilisé en autres charges.',
  'clo.cash.approve': 'Valider le comptage',
  'clo.chart.suggestionsReady': 'Les suggestions sont prêtes à être validées.',
  'clo.chart.noSuggestions': 'Aucune suggestion fiable trouvée.',
  'clo.chart.pickBeforeApprove': 'Choisissez un compte standard avant de valider.',
  'clo.chart.saved': '{{count}} correspondances de comptes enregistrées',
  'clo.chart.saveError': 'Impossible d\'enregistrer les correspondances de comptes.',
  'clo.chart.title': 'Plan comptable',
  'clo.chart.missingSubtitle': '{{count}} comptes personnalisés n\'ont pas de correspondance avec un compte standard.',
  'clo.chart.readySubtitle': 'Le plan comptable est prêt pour la clôture annuelle.',
  'clo.chart.allMapped': 'Tous les comptes personnalisés sont associés à un compte standard.',
  'clo.chart.instructions': 'Choisissez le compte standard auquel correspond chaque compte personnalisé.',
  'clo.chart.aiSuggest': 'Trouver des suggestions avec l\'IA',
  'clo.chart.accountFallback': 'Compte {{code}}',
  'clo.chart.missingMapping': 'Correspondance standard manquante',
  'clo.chart.equivalent': 'Compte standard correspondant',
  'clo.chart.reset': 'Réinitialiser les suggestions',
  'clo.chart.approve': 'Valider {{count}} suggestions',
  'clo.share.title': 'Capital social',
  'clo.share.readySubtitle': 'Le capital social est comptabilisé sur le compte 2000.',
  'clo.share.missingSubtitle': 'Vérifiez ou comptabilisez le capital social avant de terminer la clôture annuelle.',
  'clo.share.noStatus': 'Le statut du capital social n\'est pas encore calculé.',
  'clo.share.booked': 'Comptabilisé sur 2000',
  'clo.share.minimum': 'Minimum pour une AS norvégienne',
  'clo.share.lossNote': 'Les pertes ou les capitaux propres perdus ne doivent normalement pas être sortis du compte 2000. Ils sont évalués dans les capitaux propres, l\'affectation du résultat et la continuité d\'exploitation. Ce point vérifie seulement que le capital social enregistré est comptabilisé au crédit du compte 2000.',
  'clo.share.freePosting': 'Comptabiliser le capital social',
  'sharedText.app.employeePortalVerifyTitle': 'Confirmez votre adresse e-mail',
  'sharedText.auth.remember': 'Se souvenir de moi',
  'sharedText.auth.noAccount': 'Pas encore de compte ?',
  'sharedText.auth.forgotCopy': 'Saisissez l\'e-mail avec lequel vous vous connectez, et nous vous enverrons un lien pour créer un nouveau mot de passe.',
  'sharedText.acc.sentLinkTo': 'Nous avons envoyé un lien à',
  'sharedText.rep.export.year': 'Année',
  'sharedText.bank.previewVoucher': 'Aperçu du justificatif',
  'sharedText.km.returnTrip': 'Aller-retour',
  'sharedText.pay.paidOut': 'Versé',
  'sharedText.inv.col.net': 'Net',
  'sharedText.transaction.by': 'par',
  'sharedText.buy.pickCategory': 'Compte/catégorie',
  'sharedText.vat.vat': 'TVA',
  'sharedText.sup.seeVoucher': 'Voir le justificatif',
  'sharedText.bwf.correctEntry': 'Corriger l\'écriture',
  'sharedText.ap.approve': 'Valider',
  'sharedText.sale.pay.partialStatusRemaining': 'restant',
  'sharedText.helpTopics.ocrCorrection.title': 'Corriger la lecture',
  'sharedText.pay.note': 'Note',
  'sharedText.bank.openingBalance': 'Solde d\'ouverture',
  'sharedText.asset.closing': 'Solde de clôture',
  'sharedText.sale.att.dropHere': 'Déposez le justificatif ici',
  'sharedText.voucher.pickAccount': 'Choisir un compte',
  'sharedText.adv.scn.plan.interest': 'Intérêts',
  'sharedText.sale.pay.fee': 'Frais',
  'sharedText.ui.cancel': 'Annuler',
  'sharedText.bwf.selectLine': 'Choisir une ligne bancaire',
  'sharedText.bg.bankLines': 'Lignes bancaires',
  'sharedText.home.ana.ring': 'Répartition',
  'sharedText.pj.row.new': 'Nouvelle ligne',
  'sharedText.bank.bankLine': 'Ligne bancaire',
  'sharedText.helpTopics.openItem.title': 'Poste ouvert',
  'sharedText.clo.amount': 'Montant',
  'sharedText.adv.status.more': 'Plus d\'options',
  'sharedText.inboxStatus.dropReceipts': 'Déposez les justificatifs ici',
  'sharedText.bank.uploading': 'Import en cours …',
  'sharedText.set.showAll': 'Tout afficher',
  'sharedText.bank.voucherReceivedOn': 'Justificatif reçu le',
  'sharedText.set.acc.lines': 'lignes',
  'sharedText.nav.budget': 'Budget',
  'sharedText.bud.actual': 'Réel',
  'sharedText.ui.close': 'Fermer',
  'sharedText.pay.signOut': 'Se déconnecter',
  'sharedText.rf.group.firm': 'Comptable',
  'sharedText.rf.create.title': 'Créer un cabinet comptable',
  'sharedText.ui.open': 'Ouvrir',
  'sharedText.buy.next': 'Suivant',
  'sharedText.adv.docs.hide': 'Masquer',
  'sharedText.fe.decline': 'Refuser',
  'sharedText.common.yes': 'Oui',
  'sharedText.ap.review.checked': 'Contrôlé',
  'sharedText.clo.pick': 'Choisir',
  'sharedText.nav.taxReturn': 'Skattemelding',
  'sharedText.clo.financialYear': 'L\'exercice',
  'sharedText.helpTopics.residualValue.title': 'Valeur résiduelle',
  'sharedText.clo.inventoryReview.undecided': 'Choisir une évaluation',
  'sharedText.helpTopics.readyForUse.title': 'Prêt à l\'emploi',
  'sharedText.asset.work.residualValue': 'Valeur résiduelle attendue',
  'sharedText.inv.credit.line': 'Ligne',
  'sharedText.buy.paid': 'Payé',
  'sharedText.km.from': 'De',
  'sharedText.km.to': 'À',
  'sharedText.set.accountNo': 'N° de compte',
  'sharedText.sale.credit.previewReason': 'Motif :',
  'sharedText.clo.description': 'Description',
  'sharedText.prd.price': 'Prix',
  'sharedText.clo.sum': 'Total',
  'sharedText.inv.kpi.sub.exVat': 'HT',
  'sharedText.set.page': 'Page',
  'sharedText.sale.cust.org': 'N° d\'org.',
  'sharedText.trv.vehicle': 'Véhicule',
  'sharedText.ap.monthControl.finding.deviation': 'Écart possible',
  'sharedText.vat.cancel': 'Annuler',
  'sharedText.bank.review': 'Contrôler',
  'sharedText.inbox.supplierInvoice': 'Facture fournisseur',
  'sharedText.bank.roundingHelp': 'Utilisez ceci uniquement pour un petit écart d\'arrondi réel. Le montant est comptabilisé sans TVA en contrepartie de',
  'sharedText.trv.reason': 'Justification',
  'sharedText.set.acc.vatRegisteredPick': 'Choisir une réponse',
  'sharedText.set.acc.vatRegisteredUnknown': 'Je ne sais pas',
  'sharedText.set.acc.vatRegisteredFrom': 'Assujetti à la TVA depuis',
  'sharedText.vat.due': 'Échéance',
  'sharedText.pay.advance': 'Avance',
  'sharedText.pay.aga': 'AGA',
  'sharedText.inv.col.number': 'N°',
  'sharedText.onb.createPersonal': 'Créez vos finances personnelles',
  'sharedText.onb.createPersonalHelp': 'Cela crée un utilisateur distinct pour les finances personnelles, accessible depuis Mon espace et le sélecteur d\'utilisateur.',
  'sharedText.onb.noBankData': 'La connexion bancaire n\'est pas encore active. Vous pouvez importer vos relevés bancaires manuellement quand vous le souhaitez.',
  'sharedText.po.youHaveStated': 'Vous avez indiqué que',
  'sharedText.po.wealthStrongestOn': 'Votre patrimoine obtient son meilleur score sur',
  'sharedText.po.withYourAssumptions': 'Avec les hypothèses que vous avez saisies, votre patrimoine évolue d\'environ',
  'sharedText.po.splitIsEven': 'La répartition est équilibrée. Vous partagez',
  'sharedText.po.householdHasRegistered': 'Le foyer a enregistré',
  'sharedText.po.budgetTotal': 'Total du budget :',
  'sharedText.set.bank.typeTax': 'Retenue d\'impôt',
  'sharedText.clo.no': 'Non',
  'sharedText.po.showingScenario': 'Scénario affiché :',
  'sharedText.po.desiredNetWealth': 'Patrimoine net souhaité',
  'sharedText.po.lastsUntilYouAre': 'dure jusqu\'à vos',
  'sharedText.sd.transition.years': 'ans',
  'sharedText.po.lasts': 'dure',
  'sharedText.po.prioritise': 'Prioriser',
  'sharedText.adv.scn.loan.monthsUnit': 'mois',
  'sharedText.po.doYouWantToDelete': 'Voulez-vous supprimer',
  'sharedText.po.householdSpends': 'Le foyer dépense',
  'sharedText.po.iRecommend': 'Je recommande',
  'sharedText.po.debtFree': 'Sans dette',
  'sharedText.po.interestPostedAs': 'Les intérêts et remboursements de ce prêt sont comptabilisés comme',
  'sharedText.helpTopics.buffer.title': 'Réserve de trésorerie',
  'sharedText.clo.save': 'Enregistrer',
  'sharedText.adv.profile.buffer': 'Réserve souhaitée',
  'sharedText.home.legend.income': 'Produits',
  'sharedText.set.bank.typeSavings': 'Épargne',
  'sharedText.pay.category': 'Catégorie',
  'sharedText.set.account': 'Compte',
  'sharedText.po.allAccounts': 'Tous les comptes',
  'sharedText.adv.status.snooze7': 'Me le rappeler dans une semaine',
  'sharedText.po.yourHealthScoreIs': 'Votre score de santé est de',
  'sharedText.po.outOf100': 'sur 100',
  'sharedText.po.taxAssistant': 'Assistant de déclaration fiscale',
  'sharedText.cust.prev': 'Précédent',
  'sharedText.bank.finishReview': 'Terminer l\'examen',
  'sharedText.po.checkBasis': 'Base de contrôle',
  'sharedText.clo.name': 'Nom',
  'sharedText.set.text': 'Texte',
  'sharedText.sale.textLine.boldShort': 'G',
  'sharedText.sale.textLine.italicShort': 'I',
  'sharedText.sale.lines.useDivider': 'Utiliser une ligne de séparation',
  'sharedText.sale.textLine.dividerHint': 'Afficher une ligne sous le texte dans le document.',
  'sharedText.nav.products': 'Produits',
  'sharedText.sale.textLine.titleNewText': 'Nouvelle ligne de texte',
  'sharedText.prd.deleted': 'Supprimé',
  'sharedText.pay.edit': 'Modifier',
  'sharedText.clo.delete': 'Supprimer',
  'sharedText.set.loans.startDate': 'Date de début',
  'sharedText.helpTopics.unitCost.title': 'Coût unitaire',
  'sharedText.pay.optional': 'Facultatif',
  'sharedText.registry.group': 'Groupe de produits',
  'sharedText.clo.add': 'Ajouter',
  'sharedText.ha.products.account': 'Compte de produits',
  'sharedText.clo.accountNumber': 'Numéro de compte',
  'sharedText.clo.accountName': 'Nom du compte',
  'sharedText.buy.supplierNew': 'Nouveau fournisseur',
  'sharedText.auth.createAccount': 'Créer un compte',
  'sharedText.set.acc.equivalent': 'Correspond au compte',
  'sharedText.bwf.entry': 'Écriture',
  'sharedText.sale.att.upload': 'Téléverser une pièce jointe',
  'sharedText.vat.settlement': 'Règlement',
  'sharedText.ap.agent.invoice.selectRow': 'Sélectionner une facture',
  'sharedText.ap.workspace.treatmentAsset': 'Enregistrer comme immobilisation',
  'sharedText.bank.receiptLinked': 'Lié à une ligne bancaire',
  'sharedText.sd.documents.count': 'documents',
  'sharedText.set.debit': 'Débit',
  'sharedText.set.bank.accounts': 'Comptes bancaires',
  'sharedText.sd.deleteBusinessHelp': '« Supprimer l\'entreprise » supprime l\'entreprise sélectionnée après 30 jours via le backend. Il s\'agit d\'une action grave.',
  'sharedText.vat.rate': 'Taux',
  'sharedText.inv.bulk.noEmail': 'pas d\'e-mail',
  'sharedText.trv.privateRefundOf': 'Remboursement privé de',
  'sharedText.asset.group': 'Groupe',
  'sharedText.asset.opening': 'Ouverture',
  'sharedText.asset.movements': 'Mouvements',
  'sharedText.set.credit': 'Crédit',
  'sharedText.voucher.backToVat': 'Retour à la MVA-melding',
  'sharedText.vat.vatCode': 'Code TVA',
  'sharedText.bank.markVoucherLostTitle': 'Marquer le justificatif comme perdu',
  'sharedText.bank.voucherLostReason': 'Explication',
  'pay.salaryLineDeleted': 'La ligne de salaire a été supprimée.',
  'pay.salaryLineNotFound': 'La ligne de salaire n\'existe plus.',
  'pay.deleteSalaryLine': 'Supprimer la ligne de salaire',
  'pay.deleteSalaryLineConfirm': 'Voulez-vous supprimer « {{name}} » de ce brouillon de paie ?',
  'pay.accountingVouchers': 'Justificatifs comptables',
  'pay.payrollVoucher': 'Justificatif de paie',
  'pay.paymentVoucher': 'Justificatif de paiement',
  'pay.paymentVoucherInDifferentYear': 'Le paiement a été comptabilisé en {{year}} et apparaît donc dans la balance générale de cette année-là.',
  'pay.settleSalaryLiability': 'Règlement des salaires dus',
  'pay.settleEmployeeExpense': 'Règlement des frais avancés',
  'pay.paymentFromBank': 'Paiement depuis le compte bancaire',
});
